import { SCHEMA_ADD, SCHEMA_UPDATE } from './types';
import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import { apiWithToast } from '../../components/ErrorMessage';

export const getUserById = id => async (dispatch, getState) => {
  const {
    schema: {
      users: { byId },
    },
  } = getState();

  const hasDataInState = byId.id && Object.keys(byId.id).length > 2;

  if (!hasDataInState) {
    const response = await apiWithToast({
      api: () => api.get(endpoints.profile.getUserData(id)),
      type: 'getUserProfile',
      byPassCondition: 'success',
    });

    if (response) dispatch(storeUserById(response.data));
  }
};

const storeUserById = user => ({
  type: SCHEMA_ADD,
  payload: {
    schema: 'users',
    data: user,
  },
});

export const updateUserData = userData => ({
  type: SCHEMA_UPDATE,
  payload: { data: userData, schema: 'users' },
});



// WEBPACK FOOTER //
// ./src/redux/actions/userActions.js